import React from 'react';

/**
 * Reusable Amazon Shop Button Component
 * 
 * @param {Object} props - Component props
 * @param {string} props.amazonUrl - Amazon product URL
 * @param {string} props.size - Button size: 'small', 'medium', 'large' (default: 'medium')
 * @param {boolean} props.fullWidth - Whether button should take full width (default: false)
 * @param {string} props.className - Additional CSS classes
 */
const AmazonShopButton = ({ amazonUrl, size = 'medium', fullWidth = false, className = '' }) => {
  if (!amazonUrl) {
    return null;
  }

  // Size configurations
  const sizeConfig = {
    small: {
      fontSize: '0.9rem',
      padding: '8px 16px',
      minHeight: '36px'
    },
    medium: {
      fontSize: '1rem',
      padding: '12px 24px',
      minHeight: '44px'
    },
    large: {
      fontSize: '1.1rem',
      padding: '16px 32px',
      minHeight: '52px'
    }
  };

  const currentSize = sizeConfig[size] || sizeConfig.medium;

  const buttonStyle = {
    color: '#ffffff',
    fontWeight: '600',
    textDecoration: 'none',
    padding: currentSize.padding,
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#ff9900',
    background: 'linear-gradient(135deg, #ff9900 0%, #ff7700 100%)',
    boxShadow: '0 2px 8px rgba(255, 153, 0, 0.3)',
    transition: 'all 0.3s ease',
    fontSize: currentSize.fontSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: currentSize.minHeight,
    lineHeight: '1.2',
    cursor: 'pointer',
    width: fullWidth ? '100%' : 'auto',
    boxSizing: 'border-box',
    maxWidth: fullWidth ? '280px' : 'auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    position: 'relative',
    overflow: 'hidden'
  };

  const handleMouseEnter = (e) => {
    e.target.style.background = 'linear-gradient(135deg, #ff7700 0%, #ff5500 100%)';
    e.target.style.boxShadow = '0 4px 12px rgba(255, 153, 0, 0.4)';
    e.target.style.transform = 'translateY(-1px)';
  };

  const handleMouseLeave = (e) => {
    e.target.style.background = 'linear-gradient(135deg, #ff9900 0%, #ff7700 100%)';
    e.target.style.boxShadow = '0 2px 8px rgba(255, 153, 0, 0.3)';
    e.target.style.transform = 'translateY(0px)';
  };

  return (
    <a
      href={amazonUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={buttonStyle}
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={(e) => handleMouseEnter(e)}
      onBlur={(e) => handleMouseLeave(e)}
    >
      Shop on Amazon
    </a>
  );
};

export default AmazonShopButton;
